"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderDisplayCurrency = void 0;
const getOrderDisplayCurrency = (exchange_rate) => {
    if (!exchange_rate || exchange_rate?.rate === 1)
        return "THB";
    return exchange_rate.currency;
};
exports.getOrderDisplayCurrency = getOrderDisplayCurrency;
